var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTreatment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36621 3.35547C10.2833 2.90733 11.3837 3.09082 12.1055 3.8125L12.249 3.95605C12.3572 4.06423 12.4542 4.18328 12.5391 4.31055C13.0596 5.09156 13.0597 6.10866 12.5391 6.88965L12.3262 7.20898C11.5265 8.40843 11.0996 9.81822 11.0996 11.2598V12.084C11.0995 12.4773 11.0079 12.865 10.832 13.2168L10.8125 13.2568C10.7381 13.4057 10.5854 13.5 10.4189 13.5C10.2434 13.4998 10.0848 13.3948 10.0156 13.2334L9.30469 11.5742C8.8131 10.4275 7.1869 10.4275 6.69531 11.5742L5.98438 13.2334C5.9152 13.3948 5.75663 13.4998 5.58105 13.5C5.41463 13.5 5.26193 13.4057 5.1875 13.2568L5.16797 13.2168C4.9921 12.865 4.90045 12.4773 4.90039 12.084V11.2598C4.90039 9.81822 4.47346 8.40843 3.67383 7.20898L3.46094 6.88965C2.94034 6.10866 2.9404 5.09156 3.46094 4.31055C3.54578 4.18328 3.64284 4.06424 3.75098 3.95605L3.89453 3.8125C4.61634 3.09082 5.71675 2.90733 6.63379 3.35547L6.74512 3.40918C7.13592 3.60024 7.56499 3.7002 8 3.7002C8.43501 3.7002 8.86408 3.60024 9.25488 3.40918L9.36621 3.35547Z",
    stroke: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTreatment2);
export default __webpack_public_path__ + "static/media/InTreatment2.7a39be9ac186bd102d2a1deb4dc83665.svg";
export { ForwardRef as ReactComponent };